import ev from "../util/enumValue";

enum WidgetSettingsPromotionMode {
    SPECIFIC = ev('SPECIFIC', 1),
    RANDOM = ev('RANDOM', 2)
}

export default WidgetSettingsPromotionMode;
